import React from 'react';
import { Truck, User, Phone } from '@phosphor-icons/react';

const AsignacionItem = ({ icon: Icon, label, value, extra }) => (
  <div className="flex items-center gap-2">
    <Icon size={18} weight="bold" className="text-[#C1121F]" />
    <div>
      <p className="text-xs text-[#6C757D] font-['IBM_Plex_Sans']">{label}</p>
      <p className="text-sm font-medium font-['IBM_Plex_Sans'] text-[#0A0A0A]">{value}</p>
      {extra}
    </div>
  </div>
);

export const AsignacionDisplay = ({ movilizacion, showTelefonoSeparate = false, title = null }) => {
  if (!movilizacion.vehiculo && !movilizacion.conductor) return null;

  return (
    <div className="mt-4 pt-4 border-t border-[#E9ECEF]">
      {title && (
        <p className="text-xs text-[#6C757D] font-['IBM_Plex_Sans'] mb-2 font-bold uppercase tracking-wide">
          {title}
        </p>
      )}
      <div className="flex items-center gap-6 flex-wrap">
        {movilizacion.vehiculo && (
          <AsignacionItem icon={Truck} label="Vehículo" value={movilizacion.vehiculo} />
        )}
        {movilizacion.conductor && (
          <AsignacionItem
            icon={User}
            label="Conductor"
            value={movilizacion.conductor}
            extra={!showTelefonoSeparate && movilizacion.telefono_conductor
              ? <p className="text-xs text-[#495057] font-['IBM_Plex_Sans']">{movilizacion.telefono_conductor}</p>
              : null
            }
          />
        )}
        {showTelefonoSeparate && movilizacion.telefono_conductor && (
          <AsignacionItem icon={Phone} label="Tel. Conductor" value={movilizacion.telefono_conductor} />
        )}
      </div>
    </div>
  );
};
